import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const Contact = () => {
  const [recaptchaValue, setRecaptchaValue] = useState(null);

  const handleRecaptchaChange = (value) => {
    setRecaptchaValue(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!recaptchaValue) {
      alert("Please verify that you are not a robot.");
      return;
    }
    console.log("Form submitted with reCAPTCHA:", recaptchaValue);
  };

  return (
    <>
      <section className="inner-banner-sec">
        <div className="container-fluid add-padding-2">
          <div
            className="inner-bg-img"
            style={{
              backgroundImage: "url('images/contact-us-bg.jpg')",
            }}
          >
            <div className="row">
              <div className="col-12 align-self-center">
                <div className="banner_text wow fadeInLeft" data-wow-duration="2s">
                  <h1>
                    <span>Contact Us</span>
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-pg">
        <div className="container-fluid add-padding">
          <div className="row">
            <div className="col-lg-4 col-md-4 col-12">
              <div className="cont-bx">
                <h3>PHONE NUMBER</h3>
                <a href="tel:02031960378">02031960378</a>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-12">
              <div className="cont-bx">
                <h3>EMAIL</h3>
                <a href="mailto:sales@thedesignshowroom.com">
                  sales@thedesignshowroom.com
                </a>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-12">
              <div className="cont-bx">
                <h3>Address</h3>
                <a
                  href="https://maps.google.com/?q=225-226+High+St,+Brentford+TW8+0JS,+UK"
                  target="_blank"
                  rel="noreferrer"
                >
                  225-226 High Street, Brentford, Middlesex, TW8 0JS
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-md-12 mt-5">
              <div className="cont-bot-txt">
                <h3>Get in Touch</h3>
                <p>
                  We’d love to hear from you. Whether you're planning a new project or
                  seeking design guidance, our team is here to help bring your vision to life.
                </p>
                <form id="contactInquiry" onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-12">
                      <input type="text" name="firstName" placeholder="FIRST NAME" required />
                    </div>
                    <div className="col-lg-6 col-md-6 col-12">
                      <input type="text" name="lastName" placeholder="LAST NAME" required />
                    </div>
                    <div className="col-lg-6 col-md-6 col-12">
                      <input type="email" name="email" placeholder="EMAIL" required />
                    </div>
                    <div className="col-lg-6 col-md-6 col-12">
                      <input type="tel" name="phone" placeholder="YOUR PHONE" required />
                    </div>
                    <div className="col-lg-12 col-md-12 col-12">
                      <input
                        type="text"
                        name="subject"
                        placeholder="WHAT DO YOU NEED SUPPORT WITH"
                        required
                      />
                    </div>
                    <div className="col-lg-12 col-md-12 col-12">
                      <textarea
                        placeholder="MESSAGE"
                        name="message"
                        required
                      ></textarea>
                      <ReCAPTCHA
                        sitekey="6Lel4Z4UAAAAAOa8LO1Q9mqKRUiMYl_00o5mXJrR"
                        onChange={handleRecaptchaChange}
                        className="my-3"
                      />

                      <button type="submit" className="theme-btn-1" id="submitButton">
                        <span>Submit Now</span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact_map">
        <div className="container-fluid add-padding-2">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2484.602691431567!2d-0.31189411115370863!3d51.48380673974546!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48760db817e906ef:0xfff3d115b2efd971!2s225-226+High+St,+Brentford+TW8+0JS,+UK!5e0!3m2!1sen!2s!4v1752786191406!5m2!1sen!2s"
            style={{ border: 0, width: "100%", height: "450px" }}
            allowFullScreen
            loading="lazy"
            title="Google Map"
          ></iframe>
        </div>
      </section>
    </>
  );
};

export default Contact;
